import { applyTokens } from "../../../utilities/applyTokens.js";
import { createFocusStyle } from "../utils/createFocusStyle.js";
const createThumbStates = (tokens, state) => {
    const { default: defaultState, hover, active, disabled } = state;
    return Object.assign(Object.assign({ boxShadow: "none !important" }, applyTokens(defaultState)), { "&.Mui-disabled": Object.assign(Object.assign({}, applyTokens(disabled)), { "::before": {
                boxShadow: "none",
            } }), "&:not(.Mui-disabled):hover": Object.assign({}, applyTokens(hover)), "&:not(.Mui-disabled):active": Object.assign(Object.assign({}, applyTokens(active)), createFocusStyle(tokens)), "&:not(.Mui-disabled):focus, &:not(.Mui-disabled):focus-within": Object.assign({}, createFocusStyle(tokens)) });
};
const createRailAndTrackStates = (tokens, state) => {
    const { active, inactive, disabled } = state;
    const { slider } = tokens.component;
    return {
        "& .MuiSlider-rail, & .MuiSlider-track": Object.assign({ border: "none" }, applyTokens(slider.track)),
        "& .MuiSlider-rail": Object.assign({ opacity: 1 }, applyTokens(inactive)),
        "& .MuiSlider-track": Object.assign({}, applyTokens(active)),
        "&.Mui-disabled": {
            "& .MuiSlider-rail, & .MuiSlider-track": Object.assign({}, applyTokens(disabled)),
        },
    };
};
const Slider = (tokens) => {
    const { slider } = tokens.component;
    return {
        MuiSlider: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, createRailAndTrackStates(tokens, {
                    disabled: slider.track.disabled,
                    active: slider.track.active,
                    inactive: slider.track.inactive,
                })), { "& .MuiSlider-thumb": Object.assign(Object.assign({}, applyTokens(slider.handle)), createThumbStates(tokens, {
                        default: slider.handle.default,
                        hover: slider.handle.hover,
                        active: slider.handle.active,
                        disabled: slider.handle.disabled,
                    })) }),
            },
        },
    };
};
export default Slider;
//# sourceMappingURL=slider.js.map